import { KeyValue } from '@angular/common';
import { Component, computed, input, ViewEncapsulation } from '@angular/core';
import { FlowNode } from '@features/flow-ui-creator/interfaces/flow-ui.interface';
import { IOType } from '@features/flow-ui-creator/interfaces/node.interface';
import { SocketDataPipe } from '@features/flow-ui-creator/pipes/socket-data.pipe';
import { ClassicPreset } from 'rete';
import { ReteModule } from 'rete-angular-plugin/21';

@Component({
  selector: 'app-node-socket',
  imports: [ReteModule, SocketDataPipe],
  templateUrl: './node-socket.component.html',
  styleUrl: './node-socket.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class NodeSocketComponent {
  public input =
    input.required<
      KeyValue<string, ClassicPreset.Input<ClassicPreset.Socket> | ClassicPreset.Output<ClassicPreset.Socket>>
    >();

  public data = input.required<FlowNode>();
  public showLabel = input<boolean>(true);
  public index = input<string, number>('', {
    transform: (value) => {
      return value !== null || value !== undefined ? value.toString() : '';
    },
  });

  public seed = input.required<number>();
  public emit = input.required<(data: any) => void>();
  public nodeSocketType = input.required<IOType>();
  public nodeType = input.required<string>();
  public nodeTypeStyleClass = computed(() => {
    return `${this.nodeType()}-node`;
  });
}
